import React, { useState } from 'react';
import { Toaster } from 'sonner';
import { StoreProvider } from './contexts/StoreContext';
import { Landing } from './pages/Landing';
import { FieldApp } from './pages/field/FieldApp';
import { CitizenApp } from './pages/citizen/CitizenApp';
import { AdminApp } from './pages/admin/AdminApp';
import type { AppMode } from './data/scenarios';
export function App() {
  const [mode, setMode] = useState<AppMode | 'landing'>('landing');
  const exit = () => setMode('landing');
  return <StoreProvider data-id="element-0" data-mp="2mmltn2nna13q">
      <div className="h-full w-full bg-canvas font-sans" data-id="element-1" data-mp="2mn5aeg1k6jg6">
        {mode === 'landing' && <Landing onOpen={setMode} data-id="element-2" data-mp="31ayv2f5i4c5m" />}
        {mode === 'field' && <FieldApp onExit={exit} data-id="element-3" data-mp="31cjpm4rtfv3h" />}
        {mode === 'citizen' && <CitizenApp onExit={exit} data-id="element-4" data-mp="2wj8f9tnsow6t" />}
        {mode === 'admin' && <AdminApp onExit={exit} data-id="element-5" data-mp="28u5zysgmvffh" />}
      </div>
      <Toaster position="top-center" richColors closeButton toastOptions={{
      style: {
        fontFamily: 'Hind Siliguri, sans-serif'
      }
    }} data-id="element-6" data-mp="28sutulzptvl7" />
    </StoreProvider>;
}